import React, { Component } from "react";
import Card from "../../../../components/common/Card.js";
import CardHeader from "../../../../components/common/CardHeader.js";
import CardBody from "../../../../components/common/CardBody.js";
import CardTitle from "../../../../components/common/CardTitle.js";
import {
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../../components/common/MaterialCustomTablePagination.js";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import "../../../../components/admin/css/common.css";
import sweetAlert, { sweetConfirmAlert, sweetStatusAlert } from "../../../../components/common/SweetAlert.js";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { TransactionService } from "../../../../service/manage/subscription/transaction.service.js";
import { ExamTransactionService } from "../../../../service/manage/exam_subscription/examTransaction.service.js"
import { AssessmentCreditService } from "../../../../service/manage/exam_subscription/assessCredit.service.js";
import { AssessmentCreditPackPriceService } from "../../../../service/manage/exam_subscription/assessCreditPackagePrice.service.js";
import TimeZoneHandler from "../../../../handlers/TimeZoneHandler.js";
import debounce from "lodash.debounce";
import { CreditService } from "../../../../service/manage/subscription/credit.service.js";
import PageSpinner from "../../../../components/common/spinner/PageSpinner.js";
import ReactSelect from "react-select";
export default class PackageTransactions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isTableDataLoading: false,
            isStudentListLoading: false,
            isCreditAddLoading: false,
            breadcrumb2: null,
            nodeTitle: null,
            flg_list_active: null,
            transactions: "",
            showModal: false,
            selectedTransaction: null,
            transactionsPrivilege: null,
            currentPage: 0,
            limit: 10, // Set the desired limit
            offset: 0, // Set the desired offset
            totalTransactions: 10,
            search_term: "",
            isDropHidden: false,
            studentlist: [],
            selectedStudent: "",
            selectedAddStudent: "",
            selectedOption: "",
            userType: "",
            showCreditAddModal: false,
            selectedPackage: null,
            creditPackages: [],
            userIDs: "",
            isCreditPackageLoading: false,
            referenceNumber: '',
        };
        this.debouncedHandleSearchAll = debounce(this.getAllTransactions, 1000);
        this.debouncedHandleSearchUser = debounce(
            this.getAllTransactionsByUser,
            1000
        );
    }

    componentDidMount() {
        const { breadcrumb2 = null, nodeTitle = null, flg_list_active = 1 } =
            this.props.props || {};
        const userType = sessionStorage.getItem("userType");

        this.setState(
            {
                breadcrumb2: breadcrumb2,
                nodeTitle: nodeTitle || "Assessment Subscriptions",
                flg_list_active: flg_list_active || 1,
                userType: userType,
                transactionsPrivilege: this.props.transactionsPrivilege,
            },
            () => {
                if (userType === "admin") {
                    this.fetchallstudent();
                    this.getAllTransactions();
                } else if (userType === "student") {
                    this.getAllTransactionsByUser();
                }
            }
        );
    }

    getAllTransactions() {
        const mid = 100;
        const { limit, offset, search_term } = this.state;
        this.setState({ isTableDataLoading: true });
        const transaction_type = "package";
        ExamTransactionService.getAllTransactions(mid, limit, transaction_type, offset, search_term)
            .then((res) => {
                if (res.success) {
                    this.setState({
                        transactions: res.data.transactions,
                        totalTransactions: parseInt(res.data.count),
                    });
                } else {
                    sweetStatusAlert(
                        "Failed!",
                        "Error fetching Transactions. Please refresh the screen!",
                        "error"
                    );
                }
            })
            .finally(() => {
                this.setState({
                    isTableDataLoading: false,
                });
            });
    }

    getAllCreditPackages(user_id) {
        const mid = 100;
        this.setState({ isCreditPackageLoading: true });
        AssessmentCreditPackPriceService.getAllActiveCreditPackagesByID(
            mid,
            user_id
        )
            .then((res) => {
                if (res.success && res.data.credit_packages) {
                    this.setState(
                        () => ({
                            creditPackages: res.data.credit_packages,
                        })
                    );
                }
            })
            .finally(() => {
                this.setState({ isCreditPackageLoading: false });
            });
    }

    handleReferenceNumberChange = (e) => {
        this.setState({ referenceNumber: e.target.value });
    };

    toggleAddCreditModal = () => {
        this.setState(
            prevState => ({
                showCreditAddModal: !prevState.showCreditAddModal,
                selectedPackage: null,
                referenceNumber: '',
                isCreditPackageLoading: true, // Start loading
            }),
            () => {
                this.getAllCreditPackages(this.state.selectedAddStudent);
            }
        );
    };

    handlePackageSelect = (pkg) => {
        this.setState({
            selectedPackage: pkg,
            referenceNumber: ''
        });
    };

    handlePurchase = () => {
        this.setState({ isCreditPackageLoading: true });
        const { selectedPackage, referenceNumber, selectedStudent, selectedOption } = this.state;
        if (!selectedPackage) return;

        const mid = 100;
        const session_id = sessionStorage.getItem("manage_user_id");
        const table_log_id = sessionStorage.getItem("table_log_id");
        const paid_by = "Admin";
        let expirationDate = ""
        const END_OF_DAY_TIME = '18:30:00';

        if (selectedPackage.credits_expiry_type === 'date') {
            expirationDate = `${selectedPackage.credits_expiry_duration} ${END_OF_DAY_TIME}`;
        } else {
            // Get current date and time
            const currentDateTime = new Date();

            // Add the specified number of days
            const daysToAdd = parseInt(selectedPackage.credits_expiry_duration);
            const expiryDateTime = new Date(currentDateTime.getTime() + (daysToAdd * 24 * 60 * 60 * 1000));

            // Format to YYYY-MM-DD HH:mm:ss
            const year = expiryDateTime.getFullYear();
            const month = String(expiryDateTime.getMonth() + 1).padStart(2, '0');
            const day = String(expiryDateTime.getDate()).padStart(2, '0');
            const hours = String(expiryDateTime.getHours()).padStart(2, '0');
            const minutes = String(expiryDateTime.getMinutes()).padStart(2, '0');
            const seconds = String(expiryDateTime.getSeconds()).padStart(2, '0');

            expirationDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }

        const payment_obj = {
            email: sessionStorage.getItem("email"),
            unit_amount: selectedPackage.total_credit_calculated_withDiscount * 100,
            amount: selectedPackage.total_credit_calculated_withDiscount,
            credits: parseInt(selectedPackage.type_credits),
            currency_type: selectedPackage.level_currency_type,
            type_name: selectedPackage.type_name,
            node_mid: mid,
            currency_type_id: parseInt(selectedPackage.currency_id),
            type_id: parseInt(selectedPackage.type_id),
            credit_package_price_id: parseInt(selectedPackage.level_price_id),
            expiration_date: expirationDate,
            total_credits: parseInt(selectedPackage.type_credits),
            available_credits: parseInt(selectedPackage.type_credits),
            used_credits: 0,
            user_id: selectedOption.value,
            user_table_id: selectedOption.user_table_id,
            create_user_id: session_id,
            create_user_table_id: table_log_id,
            paid_by: paid_by,
            payment_method: selectedPackage.isClaim ? "Admin Free Credits" : "Admin Credits",
            reference_id: referenceNumber ? referenceNumber : "N/A",
            form_list_id: 46,
        };

        sweetConfirmAlert(
            "Are you sure?",
            "Do you want to confirm payment for selected package?",
            "warning"
        ).then(() => {
            this.setState({ isLoading: true });
            ExamTransactionService.manualExamPayment(JSON.stringify(payment_obj))
                .then((response) => {
                    if (response.success) {
                        this.toggleAddCreditModal();
                        sweetStatusAlert("Success!", response.message.success, "success");
                        this.getAllTransactions();
                    } else {
                        this.toggleAddCreditModal();
                        sweetStatusAlert("Failed!", response.message.error, "error");
                    }
                })
                .finally(() => {
                    this.setState({ isCreditPackageLoading: false });
                });
        });
    };

    calculateCreditRemainingTime = (expiryType, expiryValue) => {
        const currentDate = new Date();
        let endDate;

        if (expiryType === 'date') {
            // Handle date type (expiryValue is the end date)
            endDate = new Date(expiryValue);
        } else if (expiryType === 'days') {
            // Handle days type (expiryValue is number of days from now)
            endDate = new Date(currentDate);
            endDate.setDate(currentDate.getDate() + parseInt(expiryValue));
        } else {
            return "Invalid expiry type";
        }

        const timeDiff = endDate - currentDate;

        if (timeDiff <= 0) {
            return "Expired";
        }

        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const months = Math.floor(days / 30);
        const years = Math.floor(months / 12);

        // Calculate remaining months and days after accounting for full years
        const remainingMonths = months % 12;
        const remainingDays = days % 30;

        // Build the result string based on which time units are non-zero
        let resultParts = [];

        if (years > 0) {
            resultParts.push(`${years} year${years !== 1 ? 's' : ''}`);
        }

        if (remainingMonths > 0) {
            resultParts.push(`${remainingMonths} month${remainingMonths !== 1 ? 's' : ''}`);
        }

        if (remainingDays > 0 || resultParts.length === 0) {
            resultParts.push(`${remainingDays} day${remainingDays !== 1 ? 's' : ''}`);
        }

        // Join the parts with commas and "and" for the last item
        if (resultParts.length > 1) {
            const lastPart = resultParts.pop();
            return resultParts.join(', ') + ' and ' + lastPart;
        }

        return resultParts[0];
    };

    getAllTransactionsByUser() {
        const mid = 100;
        const { limit, offset, search_term } = this.state;
        const transaction_type = "package";
        const user_id = sessionStorage.getItem("manage_user_id");
        this.setState({ isTableDataLoading: true });
        ExamTransactionService.getAllExamTransactionsByUser(
            mid,
            user_id,
            limit,
            transaction_type,
            offset,
            search_term
        )
            .then((res) => {
                if (res.success) {
                    this.setState({
                        transactions: res.data.transactions,
                        totalTransactions: parseInt(res.data.count),
                    });
                } else {
                    sweetStatusAlert(
                        "Failed!",
                        "Error fetching Exam Transactions. Please refresh the screen!",
                        "error"
                    );
                }
            })
            .finally(() => {
                this.setState({
                    isTableDataLoading: false,
                });
            });
    }

    getAllTrasactionByParent(user_id) {
        const mid = 100;
        const { limit, offset, search_term } = this.state;
        const transaction_type = "package";
        this.setState({ isTableDataLoading: true });
        ExamTransactionService.getAllExamTransactionsByUser(
            mid,
            user_id,
            limit,
            transaction_type,
            offset,
            search_term
        )
            .then((res) => {
                if (res.success) {
                    this.setState({
                        transactions: res.data.transactions,
                        totalTransactions: parseInt(res.data.count),
                    });
                } else {
                    sweetStatusAlert(
                        "Failed!",
                        "Error fetching Exam Transactions. Please refresh the screen!",
                        "error"
                    );
                }
            })
            .finally(() => {
                this.setState({
                    isTableDataLoading: false,
                });
            });
    }
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState(() => ({ [name]: value, isModified: true }));
    };

    handleRowClick = (transaction) => {
        this.setState({
            showModal: true,
            selectedTransaction: transaction.transaction,
        });
    };

    handleModalClose = () => {
        this.setState({
            showModal: false,
            selectedTransaction: null,
        });
    };

    handlePageChange = (event, newPage) => {
        const { limit } = this.state;
        const newOffset = newPage * limit;
        this.setState(
            {
                offset: newOffset,
                isTableDataLoading: true,
                currentPage: newPage,
            },
            () => {
                const { transactionsPrivilege } = this.state;
                this.getAllTransactionsByUser();
            }
        );
    };
    fetchallstudent = () => {
        const { mid, lg_user_id, lg_user_table_id, userType } = this.props.props;
        const { search_term } = this.state;
        const form_list_id = 29;
        this.setState({ isCreditAddLoading: true });
        AssessmentCreditService.getAllStudentsForParent(
            mid,
            form_list_id,
            lg_user_id,
            lg_user_table_id,
            search_term,
            userType
        )
            .then((response) => {
                if (response.success) {
                    const userIDs = response.data.students.map(
                        (student) => student.user_id
                    );
                    this.setState({
                        studentlist: response.data.students,
                        userIDs: userIDs,
                    });
                    // this.getAllTrasactionByParent(userIDs);
                } else {
                    sweetStatusAlert(
                        "Failed!",
                        "Error fetching students. Please refresh the screen!",
                        "error"
                    );
                }
            })
            .catch((error) => {
                sweetStatusAlert(
                    "Failed!",
                    "Error fetching students. Please refresh the screen!",
                    "error"
                );
            })
            .finally(() => {
                this.setState({ isCreditAddLoading: false });
            });
    };

    handlePageOffsetChange = (newOffset, newPage) => {
        this.setState(
            {
                offset: newOffset,
                isTableDataLoading: true,
                currentPage: newPage
            },
            () => {
                const { transactionsPrivilege } = this.state
                this.getAllTransactionsByUser()
            }
        );
    };

    // handle the data fetching as per the data per page limit gets changes
    handleRowsPerPageChange = (event) => {
        const newLimit = parseInt(event.target.value, 10);
        const newPage = Math.floor(this.state.offset / newLimit);
        this.setState(
            {
                limit: newLimit,
                offset: newLimit * newPage,
                isTableDataLoading: true,
                currentPage: newPage,
            },
            () => {
                const { transactionsPrivilege } = this.state;
                this.getAllTransactionsByUser();
            }
        );
    };

    handleSearch = (event) => {
        const search_term = event.target.value.trim();

        this.setState(
            {
                search_term,
                isTableDataLoading: true,
                offset: 0,
                currentPage: 0,
            },
            () => {
                const { transactionsPrivilege } = this.state;
                if (transactionsPrivilege.isAdmin) {
                    this.debouncedHandleSearchAll();
                } else {
                    this.debouncedHandleSearchUser();
                }
            }
        );
    };
    handleStudentSelect = (event) => {
        if (!event.target.value) {
            this.setState({ selectedStudent: "" });
            this.getAllTrasactionByParent(this.state.userIDs);
            return;
        }
        let student = this.state.studentlist.find(
            (student) => student.user_id === event.target.value
        );
        this.setState({ isTableDataLoading: true });
        const selectedStudent = student.user_id;
        if (selectedStudent) {
            this.setState({ selectedStudent }, () => {
                this.getAllTrasactionByParent(selectedStudent);
            });
        }

    };

    clearStudentFilter = () => {
        this.setState({ selectedStudent: "" });
        this.getAllTrasactionByParent(this.state.userIDs);
    };

    render() {
        const {
            isTableDataLoading,
            transactions,
            showModal,
            selectedTransaction,
            transactionsPrivilege,
            currentPage,
            limit,
            totalTransactions,
            selectedStudent,
            selectedAddStudent,
            isDropHidden,
            studentlist,
            referenceNumber,
            selectedOption,
            isStudentListLoading,
            isCreditAddLoading,
            userType,
            isCreditPackageLoading,
            showCreditAddModal, creditPackages, selectedPackage
        } = this.state;

        if (!transactionsPrivilege) {
            return (
                <div>
                    <h4>Privilege not found for this section</h4>
                </div>
            );
        }
        return (
            <>
                <Card>
                    {userType !== "student" && (
                        <CardHeader>
                            {userType === "admin" && (
                                <div>
                                    {/* <CardTitle cardLabel={history.location.state.form_display_title} /> */}
                                    <CardTitle cardLabel={"Package Subscriptions"} />
                                    {/* <h3 style={{ color: 'gray' }}>{(breadcrumb2 || nodeTitle) ? `(${breadcrumb2 && breadcrumb2}${nodeTitle && nodeTitle})` : undefined}</h3> */}
                                </div>
                            )}
                            {isDropHidden ? (
                                <div className="col-md-12 d-flex justify-content-start align-items-center px-0">
                                    <div className="dropdown mb-2 px-0 col-md-4">
                                        <>
                                            {userType === "parent" && !selectedStudent && (
                                                <h3 className="thead">Please select the student</h3>
                                            )}
                                            <Form.Group
                                                as={Col}
                                                md="12"
                                                controlId="exampleForm.ControlInput3"
                                                className="px-0"
                                            >
                                                <Form.Select
                                                    aria-label="Select the student"
                                                    name="student_id"
                                                    value={selectedStudent}
                                                    onChange={this.handleStudentSelect}
                                                >
                                                    <option
                                                        value=""
                                                        style={{ fontFamily: "Inter, sans-serif" }}
                                                    >
                                                        All Students
                                                    </option>
                                                    {studentlist.map((student) => (
                                                        <option key={student.user_id} value={student.user_id}>
                                                            {student.data_concat}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </>
                                    </div>
                                    {selectedStudent && (
                                        <Button
                                            variant="secondary"
                                            onClick={this.clearStudentFilter}
                                            className="ml-5"
                                        >
                                            Clear
                                        </Button>
                                    )}
                                </div>
                            ) : null}

                        </CardHeader>
                    )}
                    <CardBody>
                        <div className="col-md-12 d-flex justify-content-start align-items-center mb-2">

                            {isCreditAddLoading && (
                                <PageSpinner id="show" text="Loading, Please wait!" />
                            )}
                            {!isCreditAddLoading && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <div className="dropdown mb-2 px-0 mr-2" style={{ flex: 1, maxWidth: '400px' }}>
                                        <CardTitle cardLabel={"Add package subscription to user"} />
                                        <Form.Group
                                            as={Col}
                                            md="12"
                                            controlId="exampleForm.ControlInput3"
                                            className="px-0"
                                        >
                                            <ReactSelect
                                                placeholder="Search by student"
                                                options={studentlist.map((student) => ({
                                                    value: student.user_id,
                                                    label: `${student.data_concat}`,
                                                    user_table_id: student.user_table_id,
                                                }))}
                                                value={selectedOption}
                                                onChange={(selectedOption) => {
                                                    const selectedValue = selectedOption?.value;
                                                    if (!selectedValue) {
                                                        this.setState({
                                                            selectedAddStudent: "",
                                                            selectedOption: "",
                                                            studentlist: [],
                                                            isCreditAddLoading: false,
                                                        });
                                                        this.fetchallstudent();
                                                        return;
                                                    }
                                                    let student = this.state.studentlist.find(
                                                        (student) => student.user_id === selectedValue
                                                    );
                                                    this.setState({
                                                        isCreditAddLoading: true,
                                                        selectedOption: selectedOption,
                                                        selectedAddStudent: student.user_id,
                                                        isCreditAddLoading: false,
                                                    });
                                                }}
                                                isClearable={true}
                                            />
                                        </Form.Group>
                                    </div>
                                    {selectedAddStudent && (
                                        <Button
                                            className="insert-btn"
                                            variant="primary"
                                            onClick={this.toggleAddCreditModal}
                                            style={{ marginTop: '24px' }}
                                        >
                                            Add Credits
                                        </Button>
                                    )}
                                </div>
                            )}
                        </div>
                        {transactions && (
                            <div className="row">
                                {transactionsPrivilege.isAdmin && (
                                    <div style={{ paddingTop: '30px' }} className="col-md-6 px-0">
                                        <CardTitle cardLabel={"User Package Subscriptions"} />
                                        <Form.Group
                                            controlId="exampleForm.ControlInput1"
                                            className="col-md-8 mb-2 px-0 mt-2"
                                        >
                                            <Form.Control
                                                type="text"
                                                placeholder="Search"
                                                onChange={this.handleSearch}
                                                className="search-bar"
                                            />
                                        </Form.Group>
                                    </div>
                                )}
                            </div>
                        )}
                        {isStudentListLoading && (
                            <PageSpinner id="show" text="Loading, Please wait!" />
                        )}
                        {isTableDataLoading ? (
                            <div className="loading-container">
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                            </div>
                        ) : (
                            <div>
                                {!isStudentListLoading && transactions.length === 0 ? (
                                    <Form.Label
                                        style={{ fontSize: "large", marginBottom: "0" }}
                                        className="pt-5"
                                    >
                                        No Exam Transactions Found!
                                    </Form.Label>
                                ) : (
                                    transactions && (
                                        <div style={{ overflow: "Auto" }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell
                                                            className="thead"
                                                            style={{ textAlign: "center" }}
                                                        >
                                                            Confirmation No
                                                        </TableCell>
                                                        <TableCell
                                                            className="thead"
                                                            style={{ textAlign: "center" }}
                                                        >
                                                            Package Name
                                                        </TableCell>
                                                        <TableCell
                                                            className="thead"
                                                            style={{ textAlign: "center" }}
                                                        >
                                                            No Of Credits
                                                        </TableCell>
                                                        <TableCell
                                                            className="thead"
                                                            style={{ textAlign: "center" }}
                                                        >
                                                            Purchased Date
                                                        </TableCell>
                                                        <TableCell
                                                            className="thead"
                                                            style={{ textAlign: "center" }}
                                                        >
                                                            Amount
                                                        </TableCell>
                                                        {transactionsPrivilege.isAdmin && (
                                                            <TableCell
                                                                className="thead"
                                                                style={{ textAlign: "center" }}
                                                            >
                                                                Currency Type
                                                            </TableCell>
                                                        )}
                                                        <TableCell
                                                            className="thead"
                                                            style={{ textAlign: "center" }}
                                                        >
                                                            Paid By
                                                        </TableCell>
                                                        <TableCell
                                                            className="thead"
                                                            style={{ textAlign: "center" }}
                                                        >
                                                            Action
                                                        </TableCell>
                                                        {userType !== "student" && (
                                                            <TableCell
                                                                className="thead"
                                                                style={{ textAlign: "center" }}
                                                            >
                                                                Student No
                                                            </TableCell>
                                                        )}
                                                        {userType !== "student" && (
                                                            <TableCell
                                                                className="thead"
                                                                style={{ textAlign: "center" }}
                                                            >
                                                                Student Name
                                                            </TableCell>
                                                        )}
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {transactions.length > 0 &&
                                                        transactions.map((transaction) => (
                                                            <TableRow>
                                                                <TableCell
                                                                    className="tData"
                                                                    style={{ textAlign: "center" }}
                                                                >
                                                                    {transaction.exam_transaction_id}
                                                                </TableCell>
                                                                <TableCell
                                                                    className="tData"
                                                                    style={{ textAlign: "center" }}
                                                                >
                                                                    {transaction.package_name}
                                                                </TableCell>
                                                                <TableCell
                                                                    className="tData"
                                                                    style={{ textAlign: "center" }}
                                                                >
                                                                    {transaction.credits}
                                                                </TableCell>
                                                                <TableCell
                                                                    className="tData"
                                                                    style={{ textAlign: "center" }}
                                                                >
                                                                    {TimeZoneHandler.convertTime(
                                                                        transaction.created_at
                                                                    )}
                                                                </TableCell>
                                                                <TableCell
                                                                    className="tData"
                                                                    style={{ textAlign: "center" }}
                                                                >
                                                                    {transaction.symbol} {transaction.amount}
                                                                </TableCell>
                                                                {transactionsPrivilege.isAdmin && (
                                                                    <TableCell
                                                                        className="tData"
                                                                        style={{ textAlign: "center" }}
                                                                    >
                                                                        {transaction.currencyName}
                                                                    </TableCell>
                                                                )}
                                                                <TableCell
                                                                    className="tData"
                                                                    style={{ textAlign: "center" }}
                                                                >
                                                                    {transaction.paid_by}
                                                                </TableCell>
                                                                <TableCell
                                                                    className="tData"
                                                                    style={{ textAlign: "center" }}
                                                                >
                                                                    <Button
                                                                        className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-eye-icon"
                                                                        title="View Note"
                                                                        key={transaction.exam_transaction_id}
                                                                        onClick={() => this.handleRowClick(transaction)}
                                                                        style={{ cursor: "pointer" }}
                                                                    />
                                                                </TableCell>
                                                                {userType !== "student" && (
                                                                    <TableCell
                                                                        className="tData"
                                                                        style={{ textAlign: "center" }}
                                                                    >
                                                                        {transaction.user_code}
                                                                    </TableCell>
                                                                )}
                                                                {userType !== "student" && (
                                                                    <TableCell
                                                                        className="tData"
                                                                        style={{ textAlign: "center" }}
                                                                    >
                                                                        {transaction.student}
                                                                    </TableCell>
                                                                )}
                                                            </TableRow>
                                                        ))}
                                                </TableBody>
                                            </Table>
                                            <MaterialCustomTablePagination
                                                totalCount={totalTransactions}
                                                currentPage={currentPage}
                                                limit={limit}
                                                handlePageChange={this.handlePageChange}
                                                handleRowsPerPageChange={this.handleRowsPerPageChange}
                                                handlePageOffsetChange={this.handlePageOffsetChange}
                                                rowsPerPageOptions={[5, 10, 20]}
                                                offset={this.state.offset}
                                            />
                                        </div>
                                    )
                                )}
                            </div>
                        )}
                    </CardBody>
                </Card>

                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={showModal}
                    onHide={this.handleModalClose}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Transaction Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedTransaction && (
                            <Form>
                                {Object.entries(selectedTransaction).map(([key, value]) => (
                                    <Row className="my-3" key={key}>
                                        <Form.Label as={Col} md="3">
                                            {key}
                                        </Form.Label>
                                        <Form.Label as={Col} md="9">
                                            {key == "Exp. Date" || key == "Purchase Date"
                                                ? TimeZoneHandler.convertTime(value)
                                                : value}
                                        </Form.Label>
                                    </Row>
                                ))}
                            </Form>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleModalClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showCreditAddModal} onHide={this.toggleAddCreditModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Select Credit Package</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {isCreditPackageLoading ? (
                            <div className="loading-container">
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                            </div>
                        ) : (
                            <>
                                <div className="row">
                                    {creditPackages.map((pkg) => (
                                        <div key={pkg.id} className="col-md-4 mb-3">
                                            <div
                                                className={`card package-card ${selectedPackage?.id === pkg.id ? 'selected' : ''}`}
                                                onClick={() => this.handlePackageSelect(pkg)}
                                                style={{
                                                    cursor: 'pointer',
                                                    border: selectedPackage?.id === pkg.id ? '2px solid #007bff' : '1px solid #ddd',
                                                    borderRadius: '5px',
                                                    padding: '15px'
                                                }}
                                            >
                                                <h5>{pkg.type_name}</h5>
                                                {(pkg.isClaim && pkg.isDisable) &&
                                                    <small style={{ color: '#306e30' }}>This free credit package is already claimed by this user</small>
                                                }
                                                <div className="package-details">
                                                    <p><strong>{pkg.type_credits} Credits</strong></p>
                                                    <p>Credit amount - {pkg.isClaim ?
                                                        'Free'
                                                        :
                                                        `${pkg.credit_amount_calculated} ${pkg.level_currency_type}`}
                                                    </p>
                                                    {(parseInt(pkg.type_discount_rate) > 0 && !pkg.isClaim) && (
                                                        <p>Package discount {parseInt(pkg.type_discount_rate)} %</p>
                                                    )}
                                                    <p>{pkg.type_description}</p>
                                                    <small>Credits expire {this.calculateCreditRemainingTime(pkg.credits_expiry_type, pkg.credits_expiry_duration)} after purchase</small>
                                                </div>
                                                <h5>Total credit amount {pkg.total_credit_calculated_withDiscount} {pkg.level_currency_type}</h5>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {selectedPackage && (
                                    <div className="selected-package-summary mt-4 p-3 bg-light rounded">
                                        <h5>Selected Package Summary</h5>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <p><strong>Package:</strong> {selectedPackage.type_name}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <p><strong>Credits:</strong> {selectedPackage.type_credits}</p>
                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <p><strong>Description:</strong> {selectedPackage.type_description}</p>
                                            </div>
                                            {(parseInt(selectedPackage.type_discount_rate) > 0 && !selectedPackage.isClaim) && (
                                                <div className="col-md-12">
                                                    <p><strong>Package discount:</strong> {parseInt(selectedPackage.type_discount_rate)} %</p>
                                                </div>
                                            )}
                                            <div className="col-md-12">
                                                <p><strong>Credit amount -</strong> {selectedPackage.isClaim ?
                                                    'Free'
                                                    :
                                                    `${selectedPackage.credit_amount_calculated} ${selectedPackage.level_currency_type}`}</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <p><strong>Expiry:</strong> Credits will expire {this.calculateCreditRemainingTime(selectedPackage.credits_expiry_type, selectedPackage.credits_expiry_duration)} after purchase</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <p><strong>Total Credit Price:</strong> {selectedPackage.total_credit_calculated_withDiscount} {selectedPackage.level_currency_type}</p>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-md-12">
                                                <Form.Group controlId="referenceNumber">
                                                    <Form.Label>Reference Number (Optional)</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter reference number if any"
                                                        value={referenceNumber}
                                                        onChange={this.handleReferenceNumberChange}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.toggleAddCreditModal}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={this.handlePurchase}
                            disabled={!selectedPackage}
                        >
                            Purchase Credits
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}
